import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

import {selectLabel, setGridSorting, setLabelIndex} from '../actions';
import {getActiveLabelSize, isGridSorting} from '../selectors';

class LabelGrid extends React.Component {
  onSortStart = () => {
    const {onSortStart} = this.props;
    this.props.actions.setGridSorting(true);
    
    if (onSortStart) {
      onSortStart(this.refs.component);
    }
  };

  onSortEnd = ({oldIndex, newIndex}) => {
    const {onSortEnd} = this.props;
    
    this.props.actions.setGridSorting(false);
    this.props.actions.setLabelIndex(oldIndex, newIndex);

    if (onSortEnd) {
      onSortEnd(this.refs.component);
    }
  };

  onSelectLabel = (index) => {
    this.props.actions.selectLabel(index);
    this.props.actions.push('/pet_search');
  };

  render() {
    const Component = this.props.component;
    const {isSorting, items} = this.props;
    const props = {
      axis: 'xy',
      isSorting,
      items,
      onSelected: this.onSelectLabel,
      onSortEnd: this.onSortEnd,
      onSortStart: this.onSortStart,
      ref: 'component'
    };

    return <Component {...this.props} {...props} />;
  }
}

function mapStateToProps(state) {
  return {
    isSorting: isGridSorting(state),
    labelSize: getActiveLabelSize(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({push, selectLabel, setGridSorting, setLabelIndex}, dispatch)
  };
}

LabelGrid.defaultProps = {
  className: "stylizedList",
  itemClass: "stylizedItem"
};

LabelGrid.propTypes = {
  actions: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  isSorting: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  itemClass: PropTypes.string.isRequired,
  labelSize: PropTypes.object.isRequired,
  onSortStart: PropTypes.func,
  onSortEnd: PropTypes.func,
  component: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(LabelGrid);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/LabelGrid.js
 **/